export enum SupportedType {
    GiftCard = 'Gift Card',
    EGiftCard = 'eGift Card',
    Reloadable = 'Reloadable',
}
